//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";

const MerchantUserLoginInfo = (props: any) => {
  const { user, profile } = props;
  const {
    register,
    setError,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        ...user,
        branch: user?.default_branch,
      };
    },
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.USER}${user?.id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) =>
          handleUpdateProfile(data, setError)
        )}
        autoComplete="off"
      >
        <div className={tw`grid  md:grid-cols-2 gap-x-4 mx-4`}>
          <TextField
            label={"Email"}
            register={register("email")}
            errors={errors?.email}
          />
          <TextField
            label={"Username"}
            register={register("username")}
            errors={errors?.username}
          />
          <PhoneNumberField
            control={control}
            label={"Mobile Number"}
            name={"mobile_number"}
            errors={errors?.mobile_number}
          />
          <ComboboxInput
            url={APIS.CREATE_BRANCH}
            queryKey={"branch"}
            register={register("branch")}
            errors={errors?.branch}
            name={"branch"}
            label={"Branch"}
            props={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button
              label={"Update"}
              // disabled={!profile?.is_superuser}
              isLoading={isPatchLoading}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default MerchantUserLoginInfo;
